<div class="container_loading">
    <div *ngIf="dialogStyle; else normalStyle" class="loading_dialog_container">
        <mat-spinner class="center_loading" [ngClass]="{ dialog_loading: dialogStyle }"></mat-spinner>
        <mat-text-hint *ngIf="hintText" class="hint_text">{{ hintText }}</mat-text-hint>
        <div *ngIf="!hintText" class="spacer"></div>
    </div>
    <ng-template #normalStyle>
        <mat-spinner class="center_loading" [ngClass]="{ dialog_loading: dialogStyle }"></mat-spinner>
        <mat-text-hint *ngIf="hintText" class="hint_text">{{ hintText }}</mat-text-hint>
        <div *ngIf="!hintText" class="spacer"></div>
    </ng-template>
</div>
